export default {
  supplierManagement: {
    // Page Titles
    pageTitle: 'Supplier Management',
    detailPageTitle: 'Supplier Scoring Details',

    // Classification Card
    classification: {
      title: 'Supplier Classification',
      all: 'All Suppliers'
    },

    // Search & Filter
    search: {
      placeholder: 'Search supplier name, contact, or mobile number',
      location: 'Location',
      button: 'Search'
    },

    // List Card
    list: {
      title: 'Supplier List',
      defaultSort: 'Default Sort',
      sortOptions: {
        scoreDesc: 'Score Descending',
        scoreAsc: 'Score Ascending'
      },
      columns: {
        name: 'Supplier Name',
        score: 'Regional Score',
        category: 'Category',
        status: 'Cooperation Status',
        operation: 'Action'
      },
      pagination: 'Showing {pageSize} per page, total {total} records'
    },

    // Detail Page Actions
    actions: {
      editScore: 'Edit Score',
      saveScore: 'Save Score',
      cancel: 'Cancel'
    },

    // Detail Page Base Info
    baseInfo: {
      title: 'Company Information',
      contact: 'Contact:',
      phone: 'Phone:',
      email: 'Email:',
      location: 'Location:',
      totalScore: 'Total Score:'
    },

    // Scoring Card
    scoring: {
      title: 'Scoring Details',
      tabs: {
        introduce: 'Introductory Evaluation',
        usage: 'Usage Rating'
      },
      columns: {
        index: 'No.',
        scope: 'Evaluation Scope',
        maxScore: 'Points',
        item: 'Evaluation Item',
        description: 'Description',
        path: 'Query Path',
        remarks: 'Remarks',
        score: 'Score',
        totalScore: 'Total Score:'
      },
      veto: {
        placeholder: 'Please enter remarks'
      },
      displayRules: {
        perEvent: '/event',
        cap: ', cap {cap}'
      },
      rules: {
        introduce: 'Introductory Evaluation Rules:\n1. Introduced: Total score 80 (inclusive) or above\n2. Reserved: Total score between 60 (inclusive) and 79\n3. Not Introduced: Total score below 59',
        usage: 'Usage Rating Rules:\n1. Excellent: Total score 85 (inclusive) or above\n2. Good: Total score 70 (inclusive) or above\n3. Cooperating: Total score 60 (inclusive) or above\n4. Rectifying: Total score below 59'
      }
    },

    // Status Enums
    enums: {
      introduce: {
        introduced: 'Introduced',
        reserved: 'Reserved',
        rejected: 'Rejected'
      },
      usage: {
        excellent: 'Excellent',
        good: 'Good',
        cooperating: 'Cooperating',
        rectifying: 'Rectifying'
      },
      cooperation: {
        cooperating: 'Cooperating',
        pending: 'Pending',
        evaluating: 'Evaluating',
        terminated: 'Terminated'
      }
    },

    // Audit Results
    audit: {
      approve: 'Approved',
      reject: 'Rejected'
    },

    // Role Translations
    roles: {
      ROLE_SHIPPER: 'Shipper',
      ROLE_CONSIGNEE: 'Consignee',
      ROLE_NOTIFY: 'Notify Party',
      ROLE_CARRIER: 'Carrier',
      ROLE_AIRLINE: 'Airline',
      ROLE_TRUCK: 'Trucker',
      ROLE_WAREHOUSE: 'Warehouse',
      ROLE_CUSTOMS: 'Customs Broker',
      ROLE_FORWARDER: 'Forwarder',
      ROLE_AGENT: 'Agent',
      ROLE_SUPPLIER: 'Supplier',
      ROLE_FACTORY: 'Factory/Manufacturer',
      ROLE_TRADER: 'Trader'
    },
    evaluationItems: {
      spaceGuarantee: 'Space Guarantee',
      priceCompetition: 'Price Competition',
      serviceEfficiency: 'Service Efficiency',
      digitalCapability: 'Digital Capability',
      comprehensive: 'Comprehensive Evaluation'
    },

    // Messages
    messages: {
      loadRolesFailed: 'Failed to load supplier role list',
      loadDataFailed: 'Failed to load data',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save scoring',
      noChanges: 'No changes detected, nothing to save',
      enterpriseIdRequired: 'Enterprise ID is required',
      scoreRangeError: 'Score is out of the allowed range',
      loadDetailFailed: 'Failed to load evaluation details',
      getEnterpriseIdFailed: 'Unable to get enterprise ID'
    }
  }
}
